export const choicePickColors = [
    '#EF3638', '#AD6200', '#027042', '#2579F4', '#7C5BE0', '#FC7FBC',
    '#E67B7B', '#97C650', '#5CD7E5', '#BE7EDF', 'rgba(0, 0, 0, 0.4)', 'rgba(0, 0, 0, 0.6)',
];

export const defaultChoiceColor = 'rgba(0, 0, 0, 0.4)'